var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 342.72 342.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0a3c79;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M685.74,496a13.19,13.19,0,0,1,13.18,13.18,170.12,170.12,0,0,1-50.08,120.58h0a171.77,171.77,0,0,1-242.53,0h0A174.16,174.16,0,0,1,377,590.61a13.18,13.18,0,1,1,23.06-12.78,147.47,147.47,0,0,0,24.85,33.27,145.4,145.4,0,0,0,205.28,0,143.76,143.76,0,0,0,42.35-101.93A13.19,13.19,0,0,1,685.74,496Z",
    transform: "translate(-356.21 -337.25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M630.21,406A145,145,0,0,0,382.57,506.25a13.18,13.18,0,0,1-26.36-.47,171.28,171.28,0,0,1,50.08-118.41h0a171.77,171.77,0,0,1,242.53,0h0a174.51,174.51,0,0,1,29.28,39.14,13.18,13.18,0,0,1-23.06,12.78A147.77,147.77,0,0,0,630.21,406Z",
    transform: "translate(-356.21 -337.25)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M675.9,349.77A13.18,13.18,0,0,1,689.08,363V432.9a13.18,13.18,0,0,1-13.18,13.18H606a13.18,13.18,0,0,1,0-26.36h56.77V363A13.18,13.18,0,0,1,675.9,349.77Z",
    transform: "translate(-356.21 -337.25)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.4,584.22A13.18,13.18,0,0,1,379.58,571h69.95a13.18,13.18,0,0,1,0,26.36H392.76v56.77a13.18,13.18,0,1,1-26.36,0Z",
    transform: "translate(-356.21 -337.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.7973c3485b39305f2a0b6195e1310760.svg";
export { ForwardRef as ReactComponent };